export default __webpack_public_path__ + "static/media/logo_Office-Depot-OfficeMax_white.57a306ca.png";